<template>
<li class="item-restaurant">
                <div class="image-restaurant" :style="'background-image:url(\'' + img + '\')'"></div>
                <div class="content-restaurant">
                    <h3 class="title-restaurant">{{ title }}</h3>
                    <div class="title-content">
                        <div>Type de Cuisine : {{ cuisine }}</div>
                        <div style="flex-direction:row; display:flex">
                            <p> 
                            <span v-if="open" style="color:green">Ouvert <span style="color:black">jusqu'à {{hour}}</span> </span>
                            <span v-else style="color:red">Fermé </span>
                            
                            </p></div>
                        <hr>
                    </div>
                    
                
                <div class="contact-restaurant">
                        <div > <img src="../assets/imgs/website.png" width="20px" alt=""> <a :href="web"> <span style="overflow-wrap:break-word"> {{ web }} </span></a></div>
                        <div > <img src="../assets/imgs/home.png" width="20px" alt=""><span>{{adresse}}</span></div>
                        <div style="display:flex"><div class="button-2">{{tel}}</div></div>
                    </div>
                </div>
                <div class="rating-and-menu"> <h2>{{score}}/5</h2>
                <div class="rating" ref="rating">
                    
                </div>
                </div>
            </li>
    
</template>

<script>
export default {
    name :'CardRestaurant',
    props: {
        title : String,
        tel : String,
        cuisine : String,
        img : String,
        open : Boolean,
        hour : JSON,
        web : String,
        adresse : String,
        score : Number,

    },
    mounted() {
        const score = this.$props.score;
        let i = 0;
        for(i = 0; i <5; i++)
        {
            let span = document.createElement('span');
            span.classList.add('fa', 'fa-star')
            if(i < score)
            {
                
                span.classList.add('checked')
                
            }
            this.$refs.rating.appendChild(span)
            
        }

    }
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap');

p{
    margin: 0;
}

hr {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    border: 1px solid lightgray;
}




a {
    color:blue!important;
    font-family: 'Montserrat', sans-serif!important;
    font-size: 1rem;
}

.contact-restaurant {
    display: flex;
    flex-direction: column;
    padding-bottom: 0.5rem;

}

.rating{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 2rem;
}

.see-menu {
    font-size: 1rem;
    font-family: 'Montserrat', sans-serif!important;
    cursor: pointer;
}

.see-menu:hover {
    text-decoration-line: underline;
}

.see-menu > img {
    transform: scaleX(-1);
}
.button-2 {
    box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
    background-color: #F5CE64;
    border-radius: 5rem;
    padding: 0.5rem;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
    text-align: center;
    margin: 0.25rem;
    cursor: default;;
    

}


.rating-and-menu {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    padding: 1rem;
    width: 26%;

}

@media (max-width: 27rem)
{
    .item-restaurant {
        width: 100%!important;
    }
}



@media (max-width: 57rem) {
    .rating-and-menu{
        width : 100%!important;
    }

    .item-restaurant {
        flex-direction: column!important;
    }

    .image-restaurant {
        width: 100%!important;
        border-bottom-left-radius: 0rem!important;
        border-top-right-radius: 2rem!important;
        padding-top: 7rem!important;
    }

    .image-restaurant::before {
        padding-top: 7rem;
    }

    .content-restaurant {
         width: 100%!important;
         text-align: center!important;
         padding-right:0.5rem ;
    }

    p {
        margin: auto
    }

    .button-2 {
        margin: auto;
    }
    
}

.image-restaurant {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position : relative;
    border-bottom-left-radius: 2rem;
    border-top-left-radius: 2rem;
    overflow: hidden;
    padding: 9%;
    width: 30%;
}

.image-restaurant::before {
    content: "";
	
    padding: 9%;
}



.content-restaurant {
    padding-left: 0.5rem;
    padding-top : 0.25rem;
    text-align: left;
    font-family: 'Montserrat', sans-serif!important;
    width: 44%;
    display: flex;
    flex-direction: column;
    
}

.item-restaurant {
    box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.28);
    border-radius: 2rem ;
    height: 20%;
    display: flex;
    width: 80%;
    margin-bottom: 1rem;
    flex-direction: row;
    margin-left: auto;
    margin-right: auto;
}

</style>